import { useEffect, useState } from "react";

// @mui material components
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "./table-data";

// Redux and API
import { useSnackbarContext } from "components/SnackBarContext";
import {
  API_ENDPOINTS,
  API_FAIL_MESSAGE,
  SUCCESS,
} from "constants/apiConstants";
import { useDispatch, useSelector } from "react-redux";
import api from "services/api";
import { setLoading } from "../../../redux/Reducers/GlobalReducer/globalSlice";

function PropertyBooking() {
  const [tableData, setTableData] = useState([]);

  const auth = useSelector((state) => state.auth);
  const { IsLoginData } = auth;
  const tableName = "Booking";
  const dispatch = useDispatch();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbarContext();
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    action: null, // "approve" or "cancel"
    data: null,
  });
  useEffect(() => {
    getTableData();
  }, []);

  const getTableData = async () => {
    try {
      dispatch(setLoading(true));
      const response = await api.get(API_ENDPOINTS.GET_BOOKINGS);
      console.log(`GET ${tableName}`, response);
      dispatch(setLoading(false));
      const { status, data, message } = response.data;
      if (status === SUCCESS) {
        setTableData(data);
      } else {
        showErrorSnackbar(message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Get ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const handleEdit = (item) => {};

  const handleApprove = (rowData) => {
    setConfirmDialog({ open: true, action: "approve", data: rowData });
  };

  const handleCancel = (rowData) => {
    setConfirmDialog({ open: true, action: "cancel", data: rowData });
  };
  const performApprove = async (rowData) => {
    // console.log("Approved:", rowData);
    // Perform API call or action
    const payload = {
      // property_id: rowData.property_id,
      // brokerId: rowData.brokerId,
      community_id: rowData.community_id,
      user_id: rowData.brokerId,
      id: rowData.id,
    };

    try {
      dispatch(setLoading(true));

      let response = await api.post(API_ENDPOINTS.APPROVE_BOOKING, payload);

      const { status, message } = response.data;
      dispatch(setLoading(false));

      if (status === SUCCESS) {
        showSuccessSnackbar(message);
        getTableData();
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Submit ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const performCancel = async (rowData) => {
    // console.log("Canceled:", rowData);
    // Perform API call or action
    const payload = {
      id: rowData.id,
      // property_id: rowData.property_id,
      // brokerId: rowData.brokerId,
    };

    try {
      dispatch(setLoading(true));

      let response = await api.post(API_ENDPOINTS.CANCEL_BOOKING, payload);

      const { status, message } = response.data;
      dispatch(setLoading(false));

      if (status === SUCCESS) {
        showSuccessSnackbar(message);
        getTableData();
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Submit ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };
  const { columns, rows } = authorsTableData(
    tableData,
    handleEdit,
    handleApprove,
    handleCancel
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {tableName}
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  // showTotalEntries={false}
                  // noEndBorder
                  onApprove={handleApprove}
                  onCancel={handleCancel}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "1rem",
            minWidth: "400px",
          },
        }}
      >
        <DialogTitle
          id="confirm-dialog-title"
          sx={{ fontWeight: "bold", fontSize: "1.25rem", textAlign: "center" }}
        >
          {confirmDialog.action === "approve"
            ? "Approve Booking"
            : "Cancel Booking"}
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            paddingTop: "1rem",
            paddingBottom: "1rem",
            fontSize: "1rem",
            color: "text.secondary",
          }}
        >
          Are you sure you want to{" "}
          {confirmDialog.action === "approve" ? "approve" : "cancel"} this
          booking?
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: "1rem" }}>
          <MDButton
            variant="contained"
            color="success"
            size="small"
            sx={{
              padding: "6px 12px",
              borderRadius: "8px",
              fontWeight: "bold",
              fontSize: "0.8rem",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#2e7d32",
                transform: "scale(1.05)",
              },
            }}
            onClick={() => {
              if (confirmDialog.action === "approve") {
                performApprove(confirmDialog.data);
              } else if (confirmDialog.action === "cancel") {
                performCancel(confirmDialog.data);
              }
              setConfirmDialog({ open: false, action: null, data: null });
            }}
          >
            Yes
          </MDButton>
          <MDButton
            variant="contained"
            color="error"
            size="small"
            sx={{
              padding: "6px 12px",
              borderRadius: "8px",
              fontWeight: "bold",
              fontSize: "0.8rem",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#c62828",
                transform: "scale(1.05)",
              },
            }}
            onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}
          >
            No
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default PropertyBooking;
